import { ReactElement } from 'react';
import styles from './spinner.module.scss';
import { SpinningLoader } from '@digital-pulse/react';

const Spinner = (): ReactElement => {
  return (
    <>
      <div
        className={`${styles.cvsSpinner} ${styles.blackBackdrop}`}
        aria-modal="true"
        tabIndex={-1}
        id="spinner"
      >
        <div className={styles.cvsSpinnerWrapper}>
          <div className={styles.cvsSpinnerContainer}>
            <SpinningLoader className="loader" state="active" size="large" status="Loading" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Spinner;
